import FileHandlerService from "./fileHandler.service";

export const FileImportService = {
    Import
};

async function Import(file: any, basePath: string, type: string) {
    type = type.split('/')[1];
    type = type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'Excel' : type;
    type = type[0].toUpperCase() + type.slice(1).toLowerCase();
   
    let url = `${basePath}/ImportFrom${type}/`;

    const result = FileHandlerService.UploadFile(url, file).then((result) => {
        return result;
    }).catch(() => {
        return false;
      });

    return result;    
}